import { Component } from "react";
import DateRangePickerV2 from "../../../lib/custom/DateRangePickerV2/DateRangePickerV2";
import SelectOption from "../../../lib/custom/SelectOption/SelectOption";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../../../assets/css/commission.css";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
class Commission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listCommission: [
        {
          id: 1,
          name: i18next.t("TradingCommissions"),
          value: 0,
        },
        {
          id: 2,
          name: i18next.t("VipMemberCommissions"),
          value: 0,
        },
      ],
      choosedCommission: {
        id: 1,
        name: i18next.t("TradingCommissions"),
        value: 0,
      },
      chartOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "areaspline",
          backgroundColor: "#181A20",
        },
        title: {
          text: null,
        },
        tooltip: {
          shared: true,
        },
        xAxis: {
          type: "datetime",
          // accessibility: {
          //   rangeDescription: this.formatRangeDateDataForChart(),
          // },
          labels: {
            format: "{value:%m/%d}",
            style: {
              color: "#fff",
            },
          },
          gridLineWidth: 1,
          gridLineDashStyle: "Dash",
        },
        yAxis: [
          {
            title: {
              text: null,
            },
            labels: { style: { color: "#e22a67" } },
            gridLineWidth: 0,
          },
          {
            title: {
              text: null,
            },
            opposite: true,
            labels: { style: { color: "#30d6ce" } },
            gridLineWidth: 0,
          },
        ],
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
              states: {
                hover: {
                  enabled: true,
                },
              },
            },
            intStart: Date.UTC(
              new Date().getUTCFullYear(),
              new Date().getUTCMonth(),
              new Date().getUTCDate()
            ),
            pointIntervalUnit: "day",
          },
          areaspline: {
            fillOpacity: 0.5,
          },
        },
        series: [
          {
            name: "",
            color: "#04c793",
            data: [240],
          },
        ],
      },
      data: [

      ],
      currentPage: 1,
      itemsPerPage: 1,
      // itemsPerPage: 7,
    };
  }
  handlePageChange = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };
  handleCommission = (item) => {
    this.setState({
      choosedCommission: item,
    });
  };
  render() {
    // Danh sách dữ liệu mẫu
    let { t } = this.props;
    const { currentPage, itemsPerPage } = this.state;

    // Tính toán dữ liệu hiển thị cho mỗi trang
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = this.state.data.slice(
      indexOfFirstItem,
      indexOfLastItem
    );

    // Tổng số trang
    const totalPages = Math.ceil(this.state.data.length / itemsPerPage);
    return (
      <div className="pl-4 pr-4 color-white">
        <div className="d-none d-lg-flex  justify-content-between color-white mt-4">
          <div className=" d-flex align-items-center" style={{ gap: "10px" }}>
            <h1 style={{ fontSize: "30px", fontWeight: 700 }}>{t('Commission')}</h1>
            <div
              className="d-flex justify-content-center align-items-center rounded-circle"
              style={{
                color: "#3dc99f",
                width: "16px",
                height: "16px",
                border: "2px solid #3dc99f",
                fontSize: "12px",
              }}
            >
              ?
            </div>
          </div>
          <div>
            <form
              action=""
              className="d-flex align-items-end justify-content-end"
              style={{
                gap: "30px",
              }}
            >
              <div className="">
                <label
                  htmlFor=""
                  style={{
                    color: "#8d97a0",
                    fontSize: "12px",
                  }}
                >
                  {t('CommissionType')}
                </label>
                <SelectOption
                  listCommission={this.state.listCommission}
                  choosedCommission={this.state.choosedCommission}
                  handleCommission={this.handleCommission}
                />
              </div>
              <div className="">
                <label
                  htmlFor=""
                  style={{
                    color: "#8d97a0",
                    fontSize: "12px",
                  }}
                >
                  {t('Date')}
                </label>
                <DateRangePickerV2 />
              </div>
              <button
                className=""
                style={{
                  backgroundColor: "#3dc99f",
                  display: "inline-block",
                  height: "44px",
                  width: "107px",
                  textAlign: "center",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {t('Search')}
              </button>
            </form>
          </div>
        </div>
        <div
          className="d-flex flex-column d-lg-none"
          style={{
            maxWidth: "378px",
            margin: "40px auto",
            padding: "20px",
            rowGap: "20px",
            border: "1px solid #8b8d96",
            borderRadius: "14px",
          }}
        >
          <label htmlFor="">{t("CommissionType")}</label>
          <div
            className="row"
            style={{
              columnGap: "10px",
              padding: "0 10px",
            }}
          >
            <button
              className="col"
              onClick={() => {
                this.handleCommission({
                  id: 1,
                  name: "Hoa Hồng Giao Dịch",
                  value: 0,
                });
              }}
              style={{
                padding: "16px 4px",
                color: "white",
                backgroundColor: `${this.state.choosedCommission.id === 1 ? "#3dc99f" : "#2F3342"
                  }`,
                borderRadius: "4px",
                fontSize: "13px",
              }}
            >
              {t("TradingCommissions")}
            </button>
            <button
              className="col"
              onClick={() => {
                this.handleCommission({
                  id: 2,
                  name: "Hoa Hồng Thành Viên Vip",
                  value: 0,
                });
              }}
              style={{
                padding: "4px 10px",
                color: "white",
                backgroundColor: `${this.state.choosedCommission.id === 2 ? "#3dc99f" : "#2F3342"
                  }`,
                borderRadius: "4px",
                fontSize: "13px",
              }}
            >
              {t("VipMemberCommissions")}
            </button>
          </div>
          <label htmlFor="">{t("Date")}</label>
          <DateRangePickerV2 />
          <button
            style={{
              color: "white",
              backgroundColor: "#3dc99f",
              padding: "14px 0px",
              borderRadius: "4px",
            }}
          >
            {t("Search")}
          </button>
        </div>
        <p style={{ color: "#8d97a0", marginBottom: "20px" }}>
          <span style={{ color: "#f02769" }}>{t("Note")}: </span>{t("CommissionNote")}
        </p>
        <div
          className="row"
          style={{
            gap: "16px",
            margin: 0,
          }}
        >
          <div
            className="col-12 col-lg"
            style={{
              border: "1px solid #303539",
              borderRadius: "20px",
              height: "457px",
              padding: 0,
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                height: "55px",
                padding: "0 20px",
              }}
            >
              <h2 style={{ fontSize: "16px", fontWeight: "700" }}>
                <span
                  className="mr-2"
                  style={{
                    color: "#3dc99f",
                    fontSize: "20px",
                  }}
                >
                  <i className="fas fa-chart-line"></i>
                </span>{" "}
                {t("TradingCommissionsChart")}
              </h2>
            </div>
            <hr
              style={{
                margin: 0,
                background: " #303539",
              }}
            />
            <div
              className="position-relative"
              style={{ height: "100%", paddingTop: "58px" }}
            >
              <HighchartsReact
                highcharts={Highcharts}
                options={this.state.chartOptions}
                containerProps={{
                  style: {
                    width: "100%",
                    height: "82%",
                    backgroundColor: "transparent",
                  },
                }}
              />
              <div
                className="position-absolute"
                style={{
                  color: "white",
                  padding: "4px 14px",
                  borderRadius: "4px",
                  backgroundColor: "#3dc99f",
                  width: "200px",
                  height: "48px",
                  top: "20px",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <p>
                  {t("Total")} {t("Receive")}: <span style={{ fontWeight: "700" }}>3.39</span>
                </p>
                <p>
                  {t("ThisMonthReceived")}:{" "}
                  <span style={{ fontWeight: "700" }}>0</span>
                </p>
              </div>
            </div>
          </div>
          <div
            className="d-lg-block d-none col-12 col-lg-8"
            style={{
              border: "1px solid #303539",
              borderRadius: "20px",
              height: "457px",
              padding: 0,
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                height: "40px",
                padding: "0 20px",
              }}
            >
              {t("TradeProfitDetail")}
            </div>
            <hr
              style={{
                background: "#303539",
                margin: 0,
              }}
            />
            <div
              style={{
                borderBottom: "1px solid #303539",
              }}
            >
              <div
                className="row d-flex align-items-center"
                style={{
                  height: "40px",
                  padding: "0 20px",
                }}
              >
                <div className="col">{t("Time")}</div>
                <div className="col">{t("Pay")}</div>
                <div className="col">{t("NumberOfTransactions")}</div>
                <div className="col">{t("TotalNumberOfTraders")}</div>
                <div className="col">{t("TradingVolume")}</div>
              </div>
            </div>
            {currentData.map((item) => {
              return (
                <div
                  className="row d-flex align-items-center"
                  style={{
                    height: "40px",
                    padding: "0 20px",
                  }}
                >
                  <div className="col">{item.time}</div>
                  <div className="col">{item.payment}</div>
                  <div className="col">{item.transactionCount}</div>
                  <div className="col">{item.houseCount}</div>
                  <div className="col">{item.transactionVolume}</div>
                </div>
              );
            })}
            <div className="pagination-container">
              {currentPage !== 1 && (
                <button
                  className="pagination-btn"
                  disabled={currentPage === 1}
                  onClick={() => this.handlePageChange(currentPage - 1)}
                >
                  {"<"}
                </button>
              )}

              {/* {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  className={`pagination-btn ${currentPage === index + 1 ? "active" : ""
                    }`}
                  onClick={() => this.handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              {currentPage !== totalPages && (
                <button
                  className="pagination-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => this.handlePageChange(currentPage + 1)}
                >
                  {">"}
                </button>
              )} */}
            </div>
          </div>
          <div
            className=" d-lg-none d-block col-12 col-lg-8 border rounded-sm mb-2"
            style={{
              margin: 0,
              padding: 0,
            }}
          >
            <div style={{ overflow: "scroll" }}>
              <table className="custom-table">
                <thead>
                  <tr>
                    <th
                      className="position-sticky"
                      style={{
                        left: 0,
                        backgroundColor: "#181A20",
                      }}
                    >
                      {t("Time")}
                    </th>
                    <th>{t("Pay")}</th>
                    <th>{t("NumberOfTransactions")}</th>
                    <th>{t("TotalNumberOfTraders")}</th>
                    <th>{t("TradingVolume")}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.map((item, index) => (
                    <tr key={index}>
                      <td
                        className="position-sticky"
                        style={{
                          left: 0,
                          backgroundColor: "#181A20",
                        }}
                      >
                        <a
                          href="#"
                          className="nickname-link"
                          onClick={(e) => {
                            e.preventDefault();
                            this.props.handleChooseUser(item);
                          }}
                        >
                          {item.time}
                        </a>
                      </td>
                      <td>{item.payment}</td>
                      <td>{item.transactionCount}</td>
                      <td>{item.houseCount}</td>
                      <td>{item.transactionVolume}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="pagination-container">
              {currentPage !== 1 && (
                <button
                  className="pagination-btn"
                  disabled={currentPage === 1}
                  onClick={() => this.handlePageChange(currentPage - 1)}
                >
                  {"<"}
                </button>
              )}

              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  className={`pagination-btn ${currentPage === index + 1 ? "active" : ""
                    }`}
                  onClick={() => this.handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
                {totalPages !== 0 && currentPage !== totalPages && (
                <button
                  className="pagination-btn"
                  disabled={currentPage === totalPages}
                  onClick={() => this.handlePageChange(currentPage + 1)}
                >
                  {">"}
                </button>
              )}
                {!totalPages && (
                    <span>
                    {t("NoData")}
                  </span>
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(Commission);
